'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function (Utils, $) {
  Utils.addClass = function (el, className) {
    if (!el) {
      console.error('Cannot add class to undefined');
      return;
    }
    if (el.classList) el.classList.add(className);else el.className += ' ' + className;
  };

  Utils.removeClass = function (el, className) {
    if (!el) {
      console.error('Cannot remove class of undefined');
      return;
    }
    if (el.classList) el.classList.remove(className);else el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
  };

  Utils.toggleClass = function (el, className) {
    if (!el) {
      console.error('Cannot toggle class of undefined');
      return;
    }
    if (el.classList) {
      el.classList.toggle(className);
    } else {
      var classes = el.className.split(' ');
      var existingIndex = classes.indexOf(className);

      if (existingIndex >= 0) classes.splice(existingIndex, 1);else classes.push(className);

      el.className = classes.join(' ');
    }
  };

  Utils.removeChildNodes = function (el) {
    while (el.firstChild) {
      el.removeChild(el.firstChild);
    }
  };

  Utils.findAncestor = function (el, ancestorSelector) {
    while (el.parentNode) {
      if (el.matches(ancestorSelector)) return el;

      el = el.parentNode;
    }

    return false;
  };

  Utils.getOffsetRelativeToAncestor = function (el, ancestorSelector) {
    var offset = {
      x: 0,
      y: 0
    };

    while (el.parentNode && !el.matches(ancestorSelector)) {
      offset.x += el.offsetLeft;
      offset.y += el.offsetTop;
      el = el.parentNode;
    }

    return offset;
  };
})(window.Utils = window.Utils || {}, jQuery);

(function (SurvivalPDP, $) {
  (function (Modal2, $) {
    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.modalToggles = [].concat(_toConsumableArray(document.querySelectorAll('[data-modal-toggle]')));
      $dom.modal = document.querySelector('.sb-hero__modal');
    };

    var toggleModal = function toggleModal(e) {
      if (!e.currentTarget.matches('[data-modal-toggle]')) return;

      var modalToggle = e.currentTarget.dataset.modalToggle;


      var modal = document.querySelector('[data-modal="' + modalToggle + '"]');
		console.log("Modal",modal);
      if (!modal) {
        console.error("The modal you are trying to toggle wasn't found on the page");
        return;
      }

      // if we are closing the modal
      if (modal.classList.contains('modal--toggled')) {
        var youtubeEmbed = modal.querySelector('iframe[src*="youtube"]');
		var vimeoEmbed = modal.querySelector('iframe[src*="vimeo"]');
        // if( $f ) {
        //   var vimeoPlayer = $f(vimeoEmbed);
        // }

        // if the modal has a youtube video, pause it
        if (youtubeEmbed) {
          youtubeEmbed.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        else if(vimeoEmbed){
          
          // if( vimeoPlayer ) {
          //   vimeoPlayer.api("pause");
          // }
        }
      }
console.log("Modal1");
      Utils.toggleClass(modal, 'modal--toggled');
    };

    var bindUIActions = function bindUIActions() {
      $dom.modalToggles.forEach(function (el) {
        return el.addEventListener('click', toggleModal);
      });
    };

    Modal2.init = function () {
      cacheDom();
      bindUIActions();
    };
  })(window.Modal2 = window.Modal2 || {}, jQuery);

  (function (SVGLineSlider, $) {
    var $dom = {};

    var Path = function Path(startX, startY, endX, endY, device) {
      _classCallCheck(this, Path);

      this.startX = startX;
      this.startY = startY;
      this.endX = endX;
      this.endY = endY;
      this.device = device;

      this.fill = 'none';
      this.stroke = '#bc5540';
      this.strokeWidth = '2';

      this.dashSize = device === 'desktop' ? '7, 3' : '14, 8';

      if (device === 'desktop') {
        if (this.startX < this.endX) {
          this.d = 'M' + startX + ' ' + startY + '\n                  V' + startY + ' \n                  H' + (endX - 30) + ' \n                  V' + endY + ' \n                  H ' + endX;
        } else {
          this.d = 'M' + startX + ' ' + startY + '\n                  V' + startY + ' \n                  H' + (endX + 30) + ' \n                  V' + endY + ' \n                  H ' + endX;
        }
      } else {
        // mobile
        this.d = '\n            M' + startX + ' ' + startY + '\n            V' + (endY - 50) + '\n            H' + endX + '\n            V' + endY + '\n          ';
      }

      this.el = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      this.el.setAttribute('d', this.d);
      this.el.setAttribute('fill', this.fill);
      this.el.setAttribute('stroke', this.stroke);
      this.el.setAttribute('stroke-width', this.strokeWidth);
      this.el.setAttribute('stroke-dasharray', this.dashSize);
      this.el.setAttribute('d', this.d);
      this.el.setAttribute('class', 'sb-features__svg-path--' + this.device);
    };

    var cacheDom = function cacheDom() {
      $dom.slickSliderOuter = $('.sb-features__slick');
      $dom.slickSliderInner = $('.sb-feature__slick');
      $dom.slickSliderInnerMobile = $('.sb-features__mobile');

      $dom.features = [].concat(_toConsumableArray(document.querySelectorAll('.sb-feature')));
      $dom.slickSlideToButtons = [].concat(_toConsumableArray(document.querySelectorAll('[data-slick-slide-to]')));
      $dom.slickNav = document.querySelector('.sb-features__nav');
      $dom.slides = [].concat(_toConsumableArray(document.querySelectorAll('.sb-features__slick .sb-features__slick-slide')));
    };

    var updateDesktopPath = function updateDesktopPath() {
      $dom.slides.forEach(function (slide) {
        var activeFeatureDesktop = slide.querySelector('.sb-features__desktop .sb-feature--active');

        if (!activeFeatureDesktop) return;

        var heading = activeFeatureDesktop.querySelector('.sb-feature__heading');
        var imageEl = slide.querySelector('.sb-feature__slick-slide');
        var svg = slide.querySelector('.sb-features__svg');

        var imageCoords = activeFeatureDesktop.dataset.point.split(',');

        var coords = {};

        var imageOffset = Utils.getOffsetRelativeToAncestor(imageEl, '.row');
        coords.x1 = imageOffset.x;
        coords.y1 = imageOffset.y;

        // add additional offset as a percentage of image width
        // this will determine where in the image the path will point to
        coords.x1 += imageEl.width * (imageCoords[0] / 100);
        coords.y1 += imageEl.height * (imageCoords[1] / 100);

        var headingOffset = Utils.getOffsetRelativeToAncestor(heading, '.row');
        coords.y2 = headingOffset.x < coords.x1 ? headingOffset.y + 10 // line attaches to right side
        : headingOffset.y + 35; // line attaches to left side

        coords.x2 = headingOffset.x < coords.x1 ? headingOffset.x + heading.offsetWidth // line attaches to right side
        : headingOffset.x - 90; // line attaches to left side

        var x1 = coords.x1,
            y1 = coords.y1,
            x2 = coords.x2,
            y2 = coords.y2;

        var path = new Path(x1, y1, x2, y2, 'desktop').el;

        Utils.removeChildNodes(svg);
        svg.appendChild(path);
      });
    };

    var updateMobilePath = function updateMobilePath() {
      $dom.slides.forEach(function (slide) {
        var activeFeatureMobile = slide.querySelector('.sb-features__mobile .sb-feature--active');

        if (!activeFeatureMobile) return;

        var imageEl = slide.querySelector('.sb-feature__slick-slide:not(.slick-cloned)');
        var svg = slide.querySelector('.sb-features__svg');

        var imageCoords = activeFeatureMobile.dataset.point.split(',');

        var coords = {};

        var imageOffset = Utils.getOffsetRelativeToAncestor(imageEl, '.row');
        coords.x1 = imageOffset.x;
        coords.y1 = imageOffset.y;

        // add additional offset as a percentage of image width
        // this is for determining where the path will point to
        // within the image
        coords.x1 += imageEl.width * (imageCoords[0] / 100);
        coords.y1 += imageEl.height * (imageCoords[1] / 100);

        var activeFeatureMobileOffset = Utils.getOffsetRelativeToAncestor(activeFeatureMobile.parentNode, '.row');

        // align to top center of heading
        coords.y2 = activeFeatureMobileOffset.y + 8;
        coords.x2 = activeFeatureMobileOffset.x + activeFeatureMobile.offsetWidth / 2;

        var x1 = coords.x1,
            y1 = coords.y1,
            x2 = coords.x2,
            y2 = coords.y2;

        var path = new Path(x1, y1, x2, y2, 'mobile').el;

        svg.appendChild(path);
      });
    };

    var update = function update() {
      updateDesktopPath();
      updateMobilePath();
    };

    var initSlick = function initSlick() {
      $dom.slickSliderOuter.slick({
        fade: true,
        dots: true,
        swipe: false,
        appendDots: $('.sb-features__nav'),
        customPaging: function customPaging(slider, i) {
          return slider.$slides[i].dataset.navTitle;
        },
        rows: 0
      });

      $dom.slickSliderInner.slick({
        fade: true,
        dots: false,
        swipe: false,
        rows: 0
      });

      $('.sb-features__mobile-navigation.num1').slick({
        asNavFor: '.sb-features__mobile.num1'
      });

      $('.sb-features__mobile.num1').slick({
        asNavFor: '.sb-features__mobile-navigation.num1',
        slide: '.sb-feature',
        swipe: true,
        dots: false,
        rows: 0,
        responsive: [{
          breakpoint: 1200,
          settings: {
            dots: true
          }
        }]
      });

      $('.sb-features__mobile-navigation.num2').slick({
        asNavFor: '.sb-features__mobile.num2'
      });

      $('.sb-features__mobile.num2').slick({
        asNavFor: '.sb-features__mobile-navigation.num2',
        slide: '.sb-feature',
        swipe: true,
        dots: false,
        rows: 0,
        responsive: [{
          breakpoint: 769,
          settings: {
            dots: true
          }
        }]
      });
    };

    var bindUIActions = function bindUIActions() {
      // change slide when sliderToggles are clicked
      [].concat(_toConsumableArray(document.querySelectorAll('[data-slick-go-to]'))).forEach(function (el) {
        el.addEventListener('click', function (e) {
          var slickGoTo = e.currentTarget.dataset.slickGoTo;

          var slickIndices = slickGoTo.split(',');

          $($dom.slickSliderInnerMobile[slickIndices[0]]).slick('slickGoTo', parseInt(slickIndices[1], 10));
        });
      });

      // when the slider has begun to slide
      $dom.slickSliderInnerMobile.on('beforeChange', function (e) {
        // first remove all sb-feature--active classes
        var activeFeatures = [].concat(_toConsumableArray(Utils.findAncestor(e.currentTarget, '.row').querySelectorAll('.sb-feature--active')));

        activeFeatures.forEach(function (el) {
          return Utils.removeClass(el, 'sb-feature--active');
        });

        // set timeout to wait for dom changes to take
        // effect before selecting the active slide
        setTimeout(function () {
          var activeSlideOuter = Utils.findAncestor(e.currentTarget, '.sb-features__slick-slide');
          var activeSlideOuterIndex = activeSlideOuter.dataset.slickIndex;

          var activeSlideInner = activeSlideOuter.querySelector('.sb-features__mobile .slick-active');

          var _activeSlideInner$dat = activeSlideInner.dataset,
              slickSlideLink = _activeSlideInner$dat.slickSlideLink,
              slickSlideIndex = _activeSlideInner$dat.slickIndex;


          var linkedImageSlide = activeSlideOuter.querySelector('\n            .sb-feature__slick [data-slick-slide-link="' + slickSlideLink + '"]:not(.slick-cloned)\n          ');

          var activeSlideToggle = activeSlideOuter.querySelector('[data-slick-go-to="' + activeSlideOuterIndex + ',' + slickSlideIndex + '"]');

          // add active classes to current slide anchors
          // these classes are used to determine where the svg path will point to
          Utils.addClass(activeSlideInner, 'sb-feature--active');
          Utils.addClass(activeSlideToggle, 'sb-feature--active');

          var slickIndex = linkedImageSlide.dataset.slickIndex;


          $dom.slickSliderInner.slick('slickGoTo', slickIndex);

          updateDesktopPath();
        }, 0);
      });

      $dom.slickSliderInnerMobile.on('afterChange', function (e) {
        updateMobilePath();
      });

      // redraw lines any time the window or slick is resized
      $dom.slickSliderInnerMobile.on('setPosition', update);
      window.addEventListener('orientationchange', update);
      window.addEventListener('resize', update);
    };

    SVGLineSlider.init = function () {
      cacheDom();
      initSlick();
      update();
      bindUIActions();
    };
  })(window.SVGLineSlider = window.SVGLineSlider || {}, jQuery);

  (function (GallerySliders, $) {
    var $dom = {};

    var cacheDom = function cacheDom() {
      $dom.slidersOuter = [].concat(_toConsumableArray(document.querySelectorAll('.sb-gallery__slider-outer')));
      $dom.slidersInner = [].concat(_toConsumableArray(document.querySelectorAll('.sb-gallery__slider-inner')));
    };

    var getSiblings = function getSiblings(element) {
      var children = [].concat(_toConsumableArray(element.parentNode.children));
      return children.filter(function (child) {
        return !child.isSameNode(element);
      });
    };

    var initSlick = function initSlick() {
      // initialize after setting parent widths
      $('.slider1 .sb-gallery__slider').slick({
        prevArrow: $('.slider1 .sb-gallery__slider-arrow--left'),
        nextArrow: $('.slider1 .sb-gallery__slider-arrow--right'),
        responsive: [{
          breakpoint: 766,
          settings: {
            centerPadding: '8%',
            centerMode: true
          }
        }]
      });

      $('.slider2 .sb-gallery__slider').slick({
        prevArrow: $('.slider2 .sb-gallery__slider-arrow--left'),
        nextArrow: $('.slider2 .sb-gallery__slider-arrow--right'),
        responsive: [{
          breakpoint: 766,
          settings: {
            centerPadding: '8%',
            centerMode: true,
            arrows: true
          }
        }]
      });
    };

    var setSlickParentWidths = function setSlickParentWidths() {
      $dom.slidersInner.forEach(function (slider) {
        slider.style.width = slider.parentNode.offsetWidth * 1.3333 + 'px';
      });
   
    };

    var bindUIActions = function bindUIActions() {
      
      // on hover add --hovered modifier
      $dom.slidersOuter.forEach(function (el) {
        return el.addEventListener('mouseenter', function () {
          Utils.addClass(el, 'sb-gallery__slider-outer--hovered');
          Utils.addClass(getSiblings(el)[0], 'sb-gallery__slider-outer--not-hovered');
        });
      });
      $dom.slidersOuter.forEach(function (el) {
        return el.addEventListener('mouseleave', function () {
          Utils.removeClass(el, 'sb-gallery__slider-outer--hovered');
          Utils.removeClass(getSiblings(el)[0], 'sb-gallery__slider-outer--not-hovered');
        });
      });

      window.addEventListener('DOMContentLoaded', setSlickParentWidths);
      window.addEventListener('resize', setSlickParentWidths);
      window.addEventListener('orientationchange', setSlickParentWidths);
    };

    GallerySliders.init = function () {
      cacheDom();
      setSlickParentWidths();
      initSlick();
      bindUIActions();
    };
  })(window.GallerySliders = window.GallerySliders || {}, jQuery);

  (function (NewsSlider, $) {
    var initSlick = function initSlick() {
      $('.sb-testimonials__companies--slider').slick({
        arrows: false,
        infinite: false,
        asNavFor: '.sb-testimonials__reviews',
        slidesToShow: 1,
        centerPadding: '25%',
        centerMode: true
      });

      $('.sb-testimonials__reviews').slick({
        asNavFor: '.sb-testimonials__companies--slider',
        fade: true,
        infinite: false,
        adaptiveHeight: false,
        dots: false,
        responsive: [{
          breakpoint: 1000,
          settings: {
            arrows: false,
            dots: true
          }
        }]
      });
    };

    var bindUIActions = function bindUIActions() {
      var btnWrapper = document.querySelector('.sb-testimonials__companies--static');

      var allButtons = [].concat(_toConsumableArray(btnWrapper.querySelectorAll('[data-slick-go-to]')));

      allButtons.forEach(function (el) {
        return el.addEventListener('click', function (e) {
          var slickGoTo = e.currentTarget.dataset.slickGoTo;


          $('.sb-testimonials__reviews').slick('slickGoTo', slickGoTo);
        });
      });

      $('.sb-testimonials__reviews').on('beforeChange', function (e) {
        setTimeout(function () {
          var activeSlide = document.querySelector('.sb-testimonials__reviews .slick-active');
          var slickIndex = activeSlide.dataset.slickIndex;


          var activeButton = btnWrapper.querySelector('[data-slick-go-to="' + slickIndex + '"]');

          allButtons.forEach(function (btn) {
            if (!btn.isSameNode(activeButton)) {
              Utils.removeClass(btn, 'sb-testimonials__company--active');
            } else {
              Utils.addClass(btn, 'sb-testimonials__company--active');
            }
          });
        }, 0);
      });
    };

    NewsSlider.init = function () {
      initSlick();
      bindUIActions();
    };
  })(window.NewsSlider = window.NewsSlider || {}, jQuery);

  SurvivalPDP.init = function () {
    Modal2.init();
    SVGLineSlider.init();
    GallerySliders.init();
    NewsSlider.init();
  };
})(window.SurvivalPDP = window.SurvivalPDP || {}, jQuery);
 Modal2.init();